export default {
  'npm_package_version': '1.0.0',
  'build_version': 'v1.1.0'
};
